import './filetables.scss'

import React, { useEffect, useState } from 'react';
import { Button, Drawer, Space, Spin } from 'antd';
import type { DrawerProps } from 'antd';
import TableDetail from './TableDetail';
import { mixGetV3 } from '../../../services/mixin';
import { selectorSourceColumnWarehouse } from '../../../store/slices/sourceColumnWarehouseSlice';
import { selectorInfoUser } from '../../../store/slices/infoUserSlice';
import { useSelector } from 'react-redux';

const ImportDataStep6 = ({ stData = {} as any, onChange = (data = {}, type = null) => {} }) => {
  const sourceColumnWarehouse = useSelector(selectorSourceColumnWarehouse);
  const user = useSelector(selectorInfoUser);

  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState<DrawerProps['placement']>('bottom');
  const [currentTab, setCurrenttab] = useState<number>(1)
  const [resultFiles, setResultFiles] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [detailData, setDetailData] = useState<any[]>([]);
  const [detailLoading, setDetailLoading] = useState<boolean>(false);
  const [detailTotal, setDetailTotal] = useState<number>(0);
  const [detailPage, setDetailPage] = useState<number>(1);
  const [detailPageSize, setDetailPageSize] = useState<number>(15);
  const [detailStatusFilter, setDetailStatusFilter] = useState<number | null>(null);

  const taskId: string = stData.step4Data?.task_id || '';

  // Map dataFiles by name for tag/icon info
  const dataFileMap: Record<string, any> = {};
  (stData.dataFiles || []).forEach((f: any) => { dataFileMap[f.name] = f; });

  const fetchResults = async () => {
    if (!taskId) return;
    setLoading(true);
    try {
      const res = await mixGetV3(`/import/file_import_result/results/${taskId}?offset=0&limit=100`, { admin_id: user.id }, { skipVehicleBrand: true });
      if (res && res.file_customer_stats) {
        const files = res.file_customer_stats.map((item: any) => {
          const fileName = item.source_name || '';
          const matched = dataFileMap[fileName];
          return {
            name: fileName,
            tag: matched?.isSource || item.df_name || '',
            total: item.total ?? 0,
            created: item.db_new ?? 0,
            updated: item.db_update ?? 0,
            skipped: item.db_exist ?? 0,
          };
        });
        setResultFiles(files);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResults();
  }, [taskId]);

  const fetchFileDetail = async (filename: string, offset = 0, limit = 15, cusStatus: number | null = null) => {
    if (!taskId) return;
    setDetailLoading(true);
    try {
      let api = `/import/file_import_result/results/${taskId}?offset=${offset}&limit=${limit}&filename=${encodeURIComponent(filename)}`;
      if (cusStatus !== null) {
        api += `&cus_status=${cusStatus}`;
      }
      const res = await mixGetV3(api, { admin_id: user.id }, { skipVehicleBrand: true });
      if (res && res.data) {
        setDetailData(res.data);
        setDetailTotal(res.total ?? res.data.length);
      }
    } finally {
      setDetailLoading(false);
    }
  };

  const showDrawer = (file: any, cusStatus: number | null = null) => {
    setSelectedFile(file);
    setCurrenttab(cusStatus === 1 ? 1 : cusStatus === 2 ? 2 : cusStatus === 0 ? 3 : 1);
    setDetailStatusFilter(cusStatus);
    setDetailPage(1);
    setDetailPageSize(15);
    setOpen(true);
    fetchFileDetail(file.name, 0, 15, cusStatus);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      {/* <div className="wrap-chart">
        <div className="wrap-label">
          <h2>Import dữ liệu thành công</h2>
        </div>
        <DonutChart stData={stData} />
      </div> */}

      <div className="file-table-wrapper">
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px' }}><Spin /></div>
        ) : (
        <div className="file-table">
          <div className="file-table-head">
            <div className="file-table-row head">
              <div className="file-table-cell border-left-radius-table">Tên file</div>
              <div className="file-table-cell">Tổng bản ghi</div>
              <div className="file-table-cell">Bản ghi tạo mới</div>
              <div className="file-table-cell">Bản ghi cập nhật</div>
              <div className="file-table-cell">Bản ghi bỏ qua</div>
            </div>
          </div>
          <div className="file-table-body">
            {resultFiles.map((file, index) => (
              <div className="file-table-row" key={index}>
                <div className="file-table-cell first-col-table file-info first-col-table">
                  <img
                    src="/images/icons/xlssIcon.png"
                    loading="lazy"
                    alt="XLS Icon"
                    className="xls-icon"
                  />
                  <div className="file-name-wrapper">
                    <div className="file-name">{file.name}</div>
                    <button className="file-tag">{file.tag}</button>
                  </div>
                </div>
                <div className="file-table-cell cts-td">
                  {file.total.toLocaleString()}
                </div>
                <div className="file-table-cell cts-td">
                  <span>{file.created.toLocaleString()}</span>
                  <span style={{ cursor: 'pointer' }} onClick={() => showDrawer(file, 1)}>
                    <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path opacity="0.3" d="M18.7289 10.0945C19.152 9.67142 19.152 8.98549 18.7289 8.56242C18.3059 8.13935 17.6199 8.13935 17.1969 8.56242L8.00447 17.7548C7.5814 18.1779 7.5814 18.8638 8.00447 19.2869C8.42753 19.7099 9.11346 19.7099 9.53653 19.2869L18.7289 10.0945Z" fill="#1890FF" />
                      <path d="M9.53646 9.64567C8.93815 9.64567 8.45312 9.16065 8.45312 8.56234C8.45312 7.96403 8.93815 7.479 9.53646 7.479H18.7288C19.3089 7.479 19.786 7.93582 19.8112 8.51528L20.1942 17.3247C20.2202 17.9224 19.7567 18.428 19.1589 18.454C18.5612 18.48 18.0555 18.0165 18.0296 17.4188L17.6916 9.64567H9.53646Z" fill="#1890FF" />
                    </svg>
                  </span>
                </div>
                <div className="file-table-cell cts-td">
                  <span>{file.updated.toLocaleString()}</span>
                  <span style={{ cursor: 'pointer' }} onClick={() => showDrawer(file, 2)}>
                    <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path opacity="0.3" d="M18.7289 10.0945C19.152 9.67142 19.152 8.98549 18.7289 8.56242C18.3059 8.13935 17.6199 8.13935 17.1969 8.56242L8.00447 17.7548C7.5814 18.1779 7.5814 18.8638 8.00447 19.2869C8.42753 19.7099 9.11346 19.7099 9.53653 19.2869L18.7289 10.0945Z" fill="#1890FF" />
                      <path d="M9.53646 9.64567C8.93815 9.64567 8.45312 9.16065 8.45312 8.56234C8.45312 7.96403 8.93815 7.479 9.53646 7.479H18.7288C19.3089 7.479 19.786 7.93582 19.8112 8.51528L20.1942 17.3247C20.2202 17.9224 19.7567 18.428 19.1589 18.454C18.5612 18.48 18.0555 18.0165 18.0296 17.4188L17.6916 9.64567H9.53646Z" fill="#1890FF" />
                    </svg>
                  </span>
                </div>
                <div className="file-table-cell cts-td">
                  <span>{file.skipped}</span>
                  <span style={{ cursor: 'pointer' }} onClick={() => showDrawer(file, 0)}>
                    <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path opacity="0.3" d="M18.7289 10.0945C19.152 9.67142 19.152 8.98549 18.7289 8.56242C18.3059 8.13935 17.6199 8.13935 17.1969 8.56242L8.00447 17.7548C7.5814 18.1779 7.5814 18.8638 8.00447 19.2869C8.42753 19.7099 9.11346 19.7099 9.53653 19.2869L18.7289 10.0945Z" fill="#1890FF" />
                      <path d="M9.53646 9.64567C8.93815 9.64567 8.45312 9.16065 8.45312 8.56234C8.45312 7.96403 8.93815 7.479 9.53646 7.479H18.7288C19.3089 7.479 19.786 7.93582 19.8112 8.51528L20.1942 17.3247C20.2202 17.9224 19.7567 18.428 19.1589 18.454C18.5612 18.48 18.0555 18.0165 18.0296 17.4188L17.6916 9.64567H9.53646Z" fill="#1890FF" />
                    </svg>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        )}
      </div>

      <Drawer
        title="Xem chi tiết bản ghi"
        placement={placement}
        width={500}
        onClose={onClose}
        open={open}
        closable={false}
        height="70vh"
        className="cts-drawer"
        extra={
          <Space>
            <span onClick={onClose} className='cts-x-mark'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </span>
          </Space>
        }
      >
        <div className="content-file">
          <img src="/images/icons/xlssIcon.png" loading='lazy' alt="" />
          <p>{selectedFile?.name || ''}</p>
          <label>{selectedFile?.tag || ''}</label>
        </div>

        <div className="tab-table">
          <div className={`tab-item ${currentTab === 1 && 'active'}`} onClick={() => {
            setCurrenttab(1);
            setDetailStatusFilter(1);
            setDetailPage(1);
            if (selectedFile) fetchFileDetail(selectedFile.name, 0, detailPageSize, 1);
          }}>
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_22942_285499)">
              <path d="M11.3392 5.66016H10.5017C10.3196 5.66016 10.1464 5.74766 10.0392 5.89766L7.23209 9.79051L5.96066 8.02623C5.85352 7.87801 5.68209 7.78873 5.49816 7.78873H4.66066C4.54459 7.78873 4.47673 7.92087 4.54459 8.01551L6.76959 11.1012C6.82215 11.1746 6.89145 11.2344 6.97172 11.2756C7.052 11.3168 7.14095 11.3384 7.2312 11.3384C7.32145 11.3384 7.4104 11.3168 7.49067 11.2756C7.57095 11.2344 7.64024 11.1746 7.6928 11.1012L11.4535 5.88694C11.5232 5.7923 11.4553 5.66016 11.3392 5.66016Z" fill="currentColor"/>
              <path d="M8 0.5C3.58214 0.5 0 4.08214 0 8.5C0 12.9179 3.58214 16.5 8 16.5C12.4179 16.5 16 12.9179 16 8.5C16 4.08214 12.4179 0.5 8 0.5ZM8 15.1429C4.33214 15.1429 1.35714 12.1679 1.35714 8.5C1.35714 4.83214 4.33214 1.85714 8 1.85714C11.6679 1.85714 14.6429 4.83214 14.6429 8.5C14.6429 12.1679 11.6679 15.1429 8 15.1429Z" fill="currentColor"/>
              </g>
              <defs>
              <clipPath id="clip0_22942_285499">
              <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
              </clipPath>
              </defs>
            </svg>
            <p>Tạo mới</p>
            <label>{selectedFile?.created?.toLocaleString() || 0}</label>
          </div>

          <div className={`tab-item ${currentTab === 2 && 'active'}`} onClick={() => {
            setCurrenttab(2);
            setDetailStatusFilter(2);
            setDetailPage(1);
            if (selectedFile) fetchFileDetail(selectedFile.name, 0, detailPageSize, 2);
          }}>
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_22942_285506)">
              <path d="M8 0.5C3.58214 0.5 0 4.08214 0 8.5C0 12.9179 3.58214 16.5 8 16.5C12.4179 16.5 16 12.9179 16 8.5C16 4.08214 12.4179 0.5 8 0.5ZM8 15.1429C4.33214 15.1429 1.35714 12.1679 1.35714 8.5C1.35714 4.83214 4.33214 1.85714 8 1.85714C11.6679 1.85714 14.6429 4.83214 14.6429 8.5C14.6429 12.1679 11.6679 15.1429 8 15.1429Z" fill="currentColor"/>
              <path d="M7.14258 11.6429C7.14258 11.8702 7.23288 12.0882 7.39363 12.2489C7.55437 12.4097 7.77239 12.5 7.99972 12.5C8.22705 12.5 8.44507 12.4097 8.60581 12.2489C8.76656 12.0882 8.85686 11.8702 8.85686 11.6429C8.85686 11.4155 8.76656 11.1975 8.60581 11.0368C8.44507 10.876 8.22705 10.7857 7.99972 10.7857C7.77239 10.7857 7.55437 10.876 7.39363 11.0368C7.23288 11.1975 7.14258 11.4155 7.14258 11.6429ZM7.57115 9.64286H8.42829C8.50686 9.64286 8.57115 9.57857 8.57115 9.5V4.64286C8.57115 4.56429 8.50686 4.5 8.42829 4.5H7.57115C7.49258 4.5 7.42829 4.56429 7.42829 4.64286V9.5C7.42829 9.57857 7.49258 9.64286 7.57115 9.64286Z" fill="currentColor"/>
              </g>
              <defs>
              <clipPath id="clip0_22942_285506">
              <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
              </clipPath>
              </defs>
            </svg>
            <p>Cập nhật</p>
            <label>{selectedFile?.updated?.toLocaleString() || 0}</label>
          </div>

          <div className={`tab-item ${currentTab === 3 && 'active'}`} onClick={() => {
            setCurrenttab(3);
            setDetailStatusFilter(0);
            setDetailPage(1);
            if (selectedFile) fetchFileDetail(selectedFile.name, 0, detailPageSize, 0);
          }}>
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_22942_285513)">
              <path d="M11.0962 5.67606C11.0962 5.59749 11.0319 5.5332 10.9533 5.5332L9.77475 5.53856L7.99975 7.65463L6.22653 5.54035L5.04618 5.53499C4.96761 5.53499 4.90332 5.59749 4.90332 5.67785C4.90332 5.71178 4.91582 5.74392 4.93725 5.7707L7.26046 8.53856L4.93725 11.3046C4.91567 11.3308 4.9037 11.3636 4.90332 11.3975C4.90332 11.4761 4.96761 11.5403 5.04618 11.5403L6.22653 11.535L7.99975 9.41892L9.77296 11.5332L10.9515 11.5386C11.0301 11.5386 11.0944 11.4761 11.0944 11.3957C11.0944 11.3618 11.0819 11.3296 11.0605 11.3028L8.74082 8.53677L11.064 5.76892C11.0855 5.74392 11.0962 5.70999 11.0962 5.67606Z" fill="currentColor" fillOpacity="0.88"/>
              <path d="M8 0.5C3.58214 0.5 0 4.08214 0 8.5C0 12.9179 3.58214 16.5 8 16.5C12.4179 16.5 16 12.9179 16 8.5C16 4.08214 12.4179 0.5 8 0.5ZM8 15.1429C4.33214 15.1429 1.35714 12.1679 1.35714 8.5C1.35714 4.83214 4.33214 1.85714 8 1.85714C11.6679 1.85714 14.6429 4.83214 14.6429 8.5C14.6429 12.1679 11.6679 15.1429 8 15.1429Z" fill="currentColor" fillOpacity="0.88"/>
              </g>
              <defs>
              <clipPath id="clip0_22942_285513">
              <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
              </clipPath>
              </defs>
            </svg>
            <p>Bỏ qua</p>
            <label>{selectedFile?.skipped?.toLocaleString() || 0}</label>
          </div>
        </div>

        <div className="wrap-table">
          {detailLoading ? (
            <div style={{ textAlign: 'center', padding: '40px' }}><Spin /></div>
          ) : (
            <TableDetail
              dataSource={detailData}
              columnList={sourceColumnWarehouse?.xem_chi_tiet_ban_ghi?.list}
              total={detailTotal}
              currentPage={detailPage}
              pageSize={detailPageSize}
              onPageChange={(page: number, size: number) => {
                setDetailPage(page);
                setDetailPageSize(size);
                if (selectedFile) fetchFileDetail(selectedFile.name, (page - 1) * size, size, detailStatusFilter);
              }}
            />
          )}
        </div>
      </Drawer>
    </>
  );
};

export default ImportDataStep6;
